<div class="atw-container">

  <!-- Featured Blog -->
  <section class="apply-section" id="featured-blog">
    <div class="section-title">
      <span>
        <b>{{ 'atw.blogs.featured.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'atw.blogs.featured.title' | transloco }}</h2>
        <p>{{ 'atw.blogs.featured.subtitle' | transloco }}</p>
      </div>
    </div>

    <article class="apply-card featured-blog-card" *ngIf="featuredBlog">
      <div class="featured-blog-media">
        <div class="blog-category-pill">
          {{ featuredBlog.categoryKey | transloco }}
        </div>

        <div class="featured-blog-shape">
          <img
            class="img-l"
            [src]="featuredBlog.iconImg"
            [alt]="featuredBlog.titleKey | transloco"
          />
        </div>
      </div>

      <div class="featured-blog-content">
        <div class="blog-meta">
          <span>{{ featuredBlog.dateKey | transloco }}</span>
          <span>•</span>
          <span>{{ featuredBlog.readTimeKey | transloco }}</span>
        </div>

        <h3>{{ featuredBlog.titleKey | transloco }}</h3>

        <p>{{ featuredBlog.excerptKey | transloco }}</p>

        <div class="keyword-list">
          <span *ngFor="let tagKey of featuredBlog.tagsKeys">
            {{ tagKey | transloco }}
          </span>
        </div>

        <a class="primary-action blog-read-action" [routerLink]="['/blog', featuredBlog.slug]">
          {{ 'atw.blogs.actions.readMore' | transloco }}
        </a>
      </div>
    </article>
  </section>

  <!-- Blogs List -->
  <section class="apply-section" id="blogs-list">
    <div class="section-title">
      <span>
        <b>{{ 'atw.blogs.list.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'atw.blogs.list.title' | transloco }}</h2>
        <p>{{ 'atw.blogs.list.subtitle' | transloco }}</p>
      </div>
    </div>

    <div class="apply-card blogs-tools">
      <label class="blogs-search">
        <span>{{ 'atw.blogs.filters.searchLabel' | transloco }}</span>

        <input
          type="text"
          [value]="searchTerm"
          (input)="onSearch($event)"
          [placeholder]="'atw.blogs.filters.searchPlaceholder' | transloco"
        />
      </label>

      <div class="blogs-categories">
        <button
          type="button"
          *ngFor="let category of categories; trackBy: trackByCategory"
          class="blog-filter-btn"
          [class.active]="activeCategory === category.id"
          (click)="setCategory(category.id)"
        >
          {{ category.labelKey | transloco }}
        </button>
      </div>
    </div>

    <div class="blogs-grid" *ngIf="filteredBlogs.length; else emptyBlogs">
      <article
        class="apply-card blog-card"
        *ngFor="let blog of filteredBlogs; trackBy: trackByBlog"
      >
        <div class="blog-card-top">
          <div class="blog-icon">
            <img
              class="img-l"
              [src]="blog.iconImg"
              [alt]="blog.titleKey | transloco"
            />
          </div>

          <div class="blog-category-pill">
            {{ blog.categoryKey | transloco }}
          </div>
        </div>

        <div class="blog-meta">
          <span>{{ blog.dateKey | transloco }}</span>
          <span>•</span>
          <span>{{ blog.readTimeKey | transloco }}</span>
        </div>

        <h3>{{ blog.titleKey | transloco }}</h3>

        <p>{{ blog.excerptKey | transloco }}</p>

        <div class="keyword-list blog-tags">
          <span *ngFor="let tagKey of blog.tagsKeys">
            {{ tagKey | transloco }}
          </span>
        </div>

        <a class="secondary-action blog-card-action" [routerLink]="['/blog', blog.slug]">
          {{ 'atw.blogs.actions.readArticle' | transloco }}
        </a>
      </article>
    </div>

    <ng-template #emptyBlogs>
      <div class="apply-card blogs-empty">
        <div>
          <img class="img-l" src="/assets/as/19.webp" alt="empty search" />
        </div>

        <h3>{{ 'atw.blogs.empty.title' | transloco }}</h3>
        <p>{{ 'atw.blogs.empty.text' | transloco }}</p>

        <button type="button" class="primary-action" (click)="resetFilters()">
          <img class="img-s" src="/assets/as/7.webp" alt="reset" />
          {{ 'atw.blogs.empty.btn' | transloco }}
        </button>
      </div>
    </ng-template>
  </section>

  <!-- CTA -->
  <section class="apply-section">
    <div class="apply-card blogs-cta">
      <div>
        <span>{{ 'atw.blogs.cta.badge' | transloco }}</span>
        <h2>{{ 'atw.blogs.cta.title' | transloco }}</h2>
        <p>{{ 'atw.blogs.cta.text' | transloco }}</p>
      </div>

      <a class="primary-action" routerLink="/smartapply">
        {{ 'atw.blogs.cta.btn' | transloco }}
      </a>
    </div>
  </section>

</div>
